import * as React from 'react';
import { ArrowListItem } from '@telia-front/arrow-list';
import Button from '@telia-front/button';
import { Card, CardContent, CardTop } from '@telia-front/card';
import { Grid, GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import { useLabels } from '@telia-front/label-provider';
import { Modal, ModalContent, ModalCloser, ModalHeader, ModalProvider, ModalTrigger } from '@telia-front/modal';
import { TabsItem } from '@telia-front/tabs';
import { TabModalContext } from '../index';
const TabModalItem = (props) => {
    const labels = useLabels();
    const { renderedElement, currentTab, setCurrentTab, variant } = React.useContext(TabModalContext);
    return renderedElement === 'tabs' ? (React.createElement(TabsItem, Object.assign({}, props), variant === 'light' ? (React.createElement(Card, { padding: "large" },
        React.createElement(CardContent, null,
            React.createElement(CardTop, null, props.children)))) : (props.children))) : (React.createElement(ModalProvider, { key: props.id, id: props.id, isOpen: currentTab === props.id, onToggle: isOpen => setCurrentTab(isOpen ? props.id : null), isClosable: false },
        React.createElement(ModalTrigger, null,
            React.createElement(ArrowListItem, { url: `#${props.id}` }, props.label)),
        React.createElement(Modal, { hasContentComponent: true, isFullScreen: true, "aria-labelledby": `${props.id}-heading` },
            React.createElement(ModalHeader, null,
                React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
                    React.createElement(GridColumn, { width: ['min'] },
                        React.createElement(ModalCloser, null,
                            React.createElement(Button, { variant: "secondary", icon: "#arrow-left", text: labels.get('close'), id: `${props.id}-close-button` }))),
                    React.createElement(GridColumn, { width: ['max'] },
                        React.createElement(Heading, { className: "h3", id: `${props.id}-heading` }, props.label)))),
            React.createElement(ModalContent, null, props.children))));
};
export { TabModalItem as default };
